<template>
    <div class="dcc-loading-overlay" role="status" :aria-label="$ml.get('dccLoadingTitle')">
        <ClipLoader :loading="true" color="#FFFFFF" size="48px" />
    </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
    name: 'DccLoadingOverlay',

    components: { ClipLoader },
};
</script>

<style scoped lang="scss">
.dcc-loading-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 50;
}
</style>
